import { sentenceCase } from 'change-case';
import { CustomCodeSample } from '@/types/customCodeSamples';
import { snakeCase } from 'change-case-all';
import {
  Collection,
  CollectionDefinition,
  QueryParamDefinition,
  Request,
  RequestAuthDefinition,
  RequestBody,
  RequestBodyDefinition,
  RequestDefinition,
  Response,
  ResponseDefinition,
  UrlDefinition,
} from 'postman-collection';

export function convertToPCF(
  input: CustomCodeSample,
  useCaseName: string,
  operationName: string,
  responseData: string,
  fileName?: string,
  forExport: boolean = false
): CollectionDefinition {
  const { uri, params, desc } = input;
  let httpMethod = input.httpMeth;
  if (!httpMethod) {
    httpMethod = 'GET';
  }
  if (useCaseName == 'default') {
    useCaseName = sentenceCase(operationName);
  }
  const path = ['api', 'v2', ...uri.split('/').filter(Boolean)];

  const paramEntries = Object.keys(params || {}).find((key) => key === 'map')
    ? Object.entries(params.map)
    : [];
  const requestBody: RequestBodyDefinition | undefined =
    httpMethod == 'POST' ? requestBodyParams(paramEntries) : undefined;
  const requestQuery: QueryParamDefinition[] | undefined =
    httpMethod == 'GET' ? queryParams(paramEntries) : undefined;

  let response: Response[] = [];
  if (responseData) {
    response = [
      new Response({
        name: forExport ? fileName : useCaseName,
        originalRequest: new Request({
          method: httpMethod,
          description: desc ?? useCaseName,
          body: requestBody,
          url: urlDefinition(path, requestQuery),
        } as RequestDefinition).toJSON(),
        body: forExport ? JSON.stringify(responseData) : responseData,
        code: 200,
      } as ResponseDefinition),
    ];
  }
  return new Collection({
    info: {
      name: fileName || snakeCase(operationName),
    },
    item: [
      {
        name: useCaseName,
        request: {
          auth: {
            type: 'basic',
            basic: [
              { key: 'username', value: '{{site_api_key}}', type: 'string' },
            ],
          } as RequestAuthDefinition,
          method: httpMethod,
          body: requestBody,
          url: urlDefinition(path, requestQuery),
        },
        response: response,
      },
    ],
  }).toJSON();
}

function queryParams(params: Array<[string, string]>) {
  return params.flatMap(([key, value]) =>
    Array.isArray(value)
      ? value.map(
          (v, index) =>
            ({ key: `${key}[${index}]`, value: v }) as QueryParamDefinition
        )
      : [{ key, value } as QueryParamDefinition]
  );
}

function requestBodyParams(params: Array<[string, string]>) {
  return new RequestBody({
    mode: RequestBody.MODES.urlencoded,
    urlencoded: queryParams(params),
  } as RequestBodyDefinition).toJSON();
}

function urlDefinition(
  path: string[],
  requestQuery: QueryParamDefinition[] | undefined
) {
  return {
    protocol: 'https',
    host: ['{{site}}', 'chargebee', 'com'],
    path: path,
    query: requestQuery,
  } as UrlDefinition;
}
